import type { MatchModelBase } from '@nf/types/odds';

export abstract class PeriodScoresBase<T extends MatchModelBase> {
	protected match: T;

	constructor(match: T) {
		this.match = match;
	}

	abstract createPeriodScores(): Array<string>;
}